import { render, staticRenderFns } from "./orderRequest.vue?vue&type=template&id=357bf043&scoped=true&"
import script from "./orderRequest.vue?vue&type=script&lang=js&"
export * from "./orderRequest.vue?vue&type=script&lang=js&"
import style0 from "./orderRequest.vue?vue&type=style&index=0&id=357bf043&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357bf043",
  null
  
)

export default component.exports